const ShippingPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* כותרת ראשית */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#9a624b] via-[#ac609c] to-[#9a624b] bg-clip-text text-transparent mb-4">
            מדיניות משלוחים
          </h1>
          <p className="text-gray-600 text-xl">
            אנו מספקים משלוחים מהירים ואמינים לכל הארץ
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#9a624b] to-[#ac609c] mx-auto rounded-full mt-6"></div>
        </div>

        {/* אפשרויות משלוח */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">אפשרויות משלוח</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">משלוח חינם</h3>
                <p className="text-gray-700 mb-3">בקנייה מעל 299₪</p>
                <ul className="text-gray-600 text-sm space-y-2">
                  <li>• משלוח עד הבית תוך 3–7 ימי עסקים</li>
                  <li>• מעקב משלוח באימייל</li>
                  <li>• ביטוח משלוח כלול</li>
                </ul>
              </div>
            </div>
            <div className="space-y-6">
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">משלוח בתשלום</h3>
                <p className="text-gray-700 mb-3">46₪ לכל הארץ</p>
                <ul className="text-gray-600 text-sm space-y-2">
                  <li>• משלוח עד הבית תוך 3–7 ימי עסקים</li>
                  <li>• מעקב משלוח באימייל</li>
                  <li>• ביטוח משלוח כלול</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* זמני משלוח */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">זמני משלוח</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">משלוחים רגילים</h3>
              <p className="leading-relaxed">
                משלוחים מתבצעים בימים א׳-ה׳ בין השעות 09:00-17:00.
                הזמנות שמתקבלות עד השעה 14:00 יישלחו באותו יום עסקים.
                הזמנות שמתקבלות אחרי השעה 14:00 יישלחו ביום העסקים הבא.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">משלוחים מיוחדים</h3>
              <p className="leading-relaxed">
                תכשיטים מותאמים אישית או בהזמנה מיוחדת יישלחו תוך 7-14 ימי עסקים.
                נעדכן אתכם על התקדמות ההזמנה באימייל.
              </p>
            </div>
          </div>
        </div>

        {/* מעקב משלוחים */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">מעקב משלוחים</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">איך לעקוב אחר המשלוח</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>קבלת אימייל עם מספר מעקב עם שליחת המשלוח</li>
                <li>עדכונים אוטומטיים על התקדמות המשלוח</li>
                <li>הודעה על הגעת המשלוח ליעד</li>
                <li>אפשרות ליצור קשר עם שירות הלקוחות</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">משלוחים לא חוקיים</h3>
              <p className="leading-relaxed">
                במקרה שהמשלוח לא הגיע בזמן או שיש בעיה, אנא צרו קשר עם שירות הלקוחות.
                נבדוק את הבעיה ונחזור אליכם בהקדם האפשרי.
              </p>
            </div>
          </div>
        </div>

        {/* אזורי משלוח */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">אזורי משלוח</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">משלוחים בישראל</h3>
              <p className="leading-relaxed">
                אנו מספקים משלוחים לכל הארץ, כולל יישובים קטנים ומושבים.
                משלוחים לאזורים מרוחקים עשויים לקחת יום נוסף.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">משלוחים לחו״ל</h3>
              <p className="leading-relaxed">
                כרגע איננו מספקים משלוחים לחו״ל.
                אנו מתכננים להרחיב את השירות בעתיד הקרוב.
              </p>
            </div>
          </div>
        </div>

        {/* יצירת קשר */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">צריכים עזרה?</h2>
          <div className="grid md:grid-cols-2 gap-8 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">פרטי קשר</h3>
              <div className="space-y-3">
                <p><strong>טלפון:</strong> 053-3332127</p>
                <p><strong>אימייל:</strong> nataly@sha-sha.co.il</p>
                <p><strong>שעות פעילות:</strong> א׳-ה׳ 09:00-19:00, ו׳ 09:00-14:00</p>
              </div>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">מידע נוסף</h3>
              <div className="space-y-3">
                <p>• משלוחים מתבצעים בימים א׳-ה׳</p>
                <p>• הזמנות עד 14:00 נשלחות באותו יום</p>
                <p>• משלוח חינם בקנייה מעל 299₪</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicyPage; 